import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/blocCommun/divers/step1';
import { TypeCoord } from '../models/TypeCoord';
@Component({
  selector: 'app-type-coord',
  templateUrl: './type-coord.component.html'
})
export class TypeCoordComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeCoord';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() formName: string;
	@Input() coord: TypeCoord;

  public step1 = new Step1();

  constructor() { }

  public ngOnInit() {
  }
  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
}

